import { useState, useCallback } from "react";

type RunResult<T> = { ok: true; value: T } | { ok: false };

export function useOptimisticMutation() {
  const [conflict, setConflict] = useState(false);
  const clearConflict = useCallback(() => setConflict(false), []);

  const run = useCallback(async <T,>(mutation: () => Promise<T>): Promise<RunResult<T>> => {
    try {
      return { ok: true, value: await mutation() };
    } catch (e: unknown) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const status = (e as any)?.statusCode ?? (e as any)?.status;
      if (status === 409) {
        setConflict(true);
        return { ok: false };
      }
      throw e;
    }
  }, []);

  return { conflict, clearConflict, run };
}
